export default "__VITE_ASSET__1c441ed2__"